import { RefObject } from 'react';
import styled from 'styled-components';
import colors from '../../../common/theme/colors';
import constants from '../../../common/theme/constants';

export const ControlsWrapper = styled.div`
  position: relative;
  width: 100%;
`;

export const RangeLabel = styled.div<{ ref?: RefObject<HTMLDivElement>; thumbSize: number }>`
  margin-bottom: ${constants.spacing.absolute.m}px;
  position: relative;
`;

export const ResetLink = styled.a`
  color: ${colors.blue_55};
  cursor: pointer;
  position: absolute;
  right: 0;
  top: -${constants.spacing.absolute.xl}px;
`;

export const StyledMinMaxLabel = styled.span<{ max?: boolean }>`
  font-size: ${constants.fontSize.text_14}rem;
  float: ${({ max }) => (max ? 'right' : 'left')};
  text-align: ${({ max }) => (max ? 'right' : 'left')};
  margin-right: 0;
  margin-top: ${constants.spacing.absolute.m}px;
`;

export const StyledLabel = styled.label<{ error?: unknown; for?: string }>`
  && {
    font-size: ${constants.fontSize.text_14}rem;
    color: ${({ error, theme }) => (error ? theme.error : theme.label)};
    margin-bottom: ${constants.spacing.m}rem;
  }
`;

export const FormInputError = styled.div`
  color: ${({ theme }) => theme.error};
  font-size: ${constants.fontSize.text_14}rem;
  margin: ${constants.spacing.absolute.s}px 0 0;
`;

export const RequiredIdentifier = styled.span`
  &:after {
    content: '*';
  }
`;

export const StyledRangeWrapper = styled.div<{ disabled?: boolean }>`
  clear: both;
  padding-top: 0.5em;
  padding-bottom: 1em;
  &:disabled,
  &.disabled {
    cursor: not-allowed;
    .track-section {
      background-color: ${colors.gray_20};
    }
    .slider-handle {
      background-color: ${colors.gray_20};
      border: 1px solid ${colors.gray_20};
      pointer-events: none;
    }
  }
`;

export const StyledTrack = styled.div<{ trackHeight?: number }>`
  background-color: ${colors.gray_20};
  position: relative;
  height: ${({ trackHeight }) => trackHeight}px;
  transition: all 0.3s ease-out;
  &.focus,
  &:focus {
    /* not sure what this color should be */
    background-color: ${colors.gray_20};
  }
`;

export const TrackSection = styled.div<{ trackHeight?: number }>`
  height: ${({ trackHeight }) => trackHeight}px;
  position: absolute;
  background-color: ${colors.orange_55};
  width: auto;
`;

export const StyledRangeHandle = styled.div<{ size: number }>`
  background: ${colors.orange_55};
  border-radius: ${({ size }) => size / 2}px;
  border: 1px solid ${colors.orange_55};
  cursor: pointer;
  height: ${({ size }) => size}px;
  width: ${({ size }) => size}px;
  margin: 0;
  padding: 0;
  position: absolute;  
  top: -${({ size }) => size / 2}px;
  outline: 0;
  &:focus, &:hover {
    transition: box-shadow 0.3s ease-out, background 0.2s ease-out;
    border: 1px solid ${colors.orange_55};
    background: ${colors.orange_55};
    box-shadow: 0 0 0 ${constants.border.width}px ${({ theme }) => theme.focus};
  }
}
`;
